// src/session-code.ts
var SESSION_CODE_ALPHABET = "23456789ABCDEFGHJKMNPQRSTUVWXYZ";
var SESSION_CODE_LENGTH = 5;
var SESSION_CODE_REGEX = new RegExp(
  `^[${SESSION_CODE_ALPHABET}]{${SESSION_CODE_LENGTH}}$`
);
function generateSessionCode() {
  const cryptoApi = globalThis.crypto;
  if (!cryptoApi || typeof cryptoApi.getRandomValues !== "function") {
    throw new Error(
      "Web Crypto API not available. Lume requires Node \u2265 19 or a modern browser."
    );
  }
  const alphabetSize = SESSION_CODE_ALPHABET.length;
  const acceptThreshold = Math.floor(256 / alphabetSize) * alphabetSize;
  const out = [];
  const buffer = new Uint8Array(SESSION_CODE_LENGTH * 2);
  while (out.length < SESSION_CODE_LENGTH) {
    cryptoApi.getRandomValues(buffer);
    for (const byte of buffer) {
      if (byte >= acceptThreshold) {
        continue;
      }
      out.push(SESSION_CODE_ALPHABET[byte % alphabetSize]);
      if (out.length === SESSION_CODE_LENGTH) {
        break;
      }
    }
  }
  return out.join("");
}
function isSessionCode(value) {
  return SESSION_CODE_REGEX.test(value);
}
function normalizeSessionCode(input) {
  const candidate = input.trim().toUpperCase();
  return isSessionCode(candidate) ? candidate : null;
}

// src/types.ts
var ok = (value) => ({ ok: true, value });
var err = (error) => ({ ok: false, error });
export {
  SESSION_CODE_ALPHABET,
  SESSION_CODE_LENGTH,
  SESSION_CODE_REGEX,
  err,
  generateSessionCode,
  isSessionCode,
  normalizeSessionCode,
  ok
};
//# sourceMappingURL=index.mjs.map